import Panel from 'Components/Panel';
import SimpleList from 'Components/SimpleList';
import { actions as siteActions } from 'ducks/sites';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { unixToDate } from 'utils/date';
import statusToComponent from 'utils/statusToComponent';
import icons from 'utils/ui/icons';

const siteProperties = model => [
    { label: 'ID', content: model.id },
    { label: 'Organization', content: model.organization_name },
    { label: 'Name', content: model.name },
    { label: 'Address', content: model.address.full_address },
    { label: 'Coordinates', content: `lat: ${model.address.latitude} - lng: ${model.address.longitude}` },
    { label: 'Status', content: statusToComponent(model.status) },
    { label: 'Creation', content: `${unixToDate(model.created_at)} - ${model.creator_name}` },
    { label: 'Update', content: `${unixToDate(model.updated_at)} - ${model.updater_name}` }
];

const Component = props => {
    const site = useSelector(state => state.sites.models[props.siteId]);
    const submitting = useSelector(state => state.sites.submitting);

    const dispatch = useDispatch();
    const { remove, refreshStatus } = ({
        remove: (id, redirect) => dispatch(siteActions.remove(id, redirect)),
        refreshStatus: id => dispatch(siteActions.refreshStatus(id))
    });

    let buttons = [
        {
            confirmationHeader: 'Refresh Confirmation',
            confirmationText: 'Are you sure you want to refresh site status?',
            icon: icons.statusRefresh,
            onClick: () => refreshStatus(site.id),
            submitting: submitting,
            tooltip: 'Refresh Status'
        },
        {
            confirmationHeader: 'Delete Confirmation',
            confirmationText: 'Are you sure you want to delete?',
            submitting: submitting,
            icon: icons.trash,
            onClick: () => remove(site.id, '/map'),
            tooltip: 'Delete',
            disabled: true
        }
    ];

    return (
        <Panel buttons={buttons}>
            <SimpleList content={siteProperties(site)}/>
        </Panel>
    );
};

export default Component;
